<template>
  <span
      v-for="error in errors"
      v-show="errors.length > 0"
      class="error__message"
      v-html="error"
  />
</template>

<script>
export default {
  name:  "ValidationError",
  props: {
    errors: {
      type: Array
    }
  },
};
</script>
